import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { capturarVendedorDeUrl } from './services/vendedor'

// Antes de que el router cambie la URL: ?v=codigo asigna el vendedor
capturarVendedorDeUrl()

createRoot(document.getElementById('root')!).render(
  <App />,
)
